<template>
  <div>
    <PCNavbar selectIndex="2"/>
    <!-- <MobileNavBar :currentActive="2" /> -->
    <Product/>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
// import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import Product from '@/components/product/index.vue'
export default {
  components: {
    PCNavbar,
    Product
    // MobileNavBar
  },
}
</script>

<style>
</style>